/**
 * Created by mkoehler on 01.02.16.
 */
import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.TabSlider = function (element) {
        this.$tabSlider = $(element);
        this.$sliderControls = $('.sliderControls', this.$tabSlider);
        this.$tabContents = $('.tabContents', this.$tabSlider);
        this.$window = $(window);

        this.slideInterval = null;
        this.count = this.$sliderControls.find('li').length;
        this.counter = 2;

        this.swipingPoint = 75;
        this.slideAnimatedWithSwipe = false;

        this.init();
    };

    OndigoNS.TabSlider.prototype = {
        init: function () {
            var _instance = this;
            this.setTabHeadPosition();
            this.initAutoSlide();

            this.$sliderControls.on('click', function () {
                clearInterval(_instance.slideInterval);
            });

            setTimeout(function () {
                _instance.setTabHeadPosition();
                setTimeout(function () {
                    _instance.setTabHeadPosition();
                    setTimeout(function () {
                        _instance.setTabHeadPosition();
                    }, 300);
                }, 300);
            }, 300);

            if (OndigoNS.Utils.hasTouchscreen()) {
                this.$window.on('orientationchange', function () {
                    setTimeout(function () {
                        _instance.setTabHeadPosition();
                        if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                            _instance.$tabContents.swipe('enable');
                        } else {
                            _instance.$tabContents.swipe('disable');
                        }
                        setTimeout(function () {
                            _instance.setTabHeadPosition();
                            setTimeout(function () {
                                _instance.setTabHeadPosition();
                            }, 300);
                        }, 300);
                    }, 100);
                });

                this.$tabContents.swipe({
                    swipeStatus: $.proxy(_instance.swipeSlide, this),
                    threshold: 100,
                    maxTimeThreshold: 2500,
                    fingers: 'all',
                    allowPageScroll: 'vertical',
                    click: function (event, target) {
                        $(target).click();
                    }
                });
            } else {
                this.$window.on('resize', function () {
                    setTimeout(function () {
                        _instance.setTabHeadPosition();
                    }, 100);
                });

                this.$tabSlider.on('mouseover', function () {
                    clearInterval(_instance.slideInterval);
                });
                this.$tabSlider.on('mouseout', function () {
                    _instance.initAutoSlide();
                });
            }
        },
        setTabHeadPosition : function () {
            if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                this.$sliderControls.css('top', $('.imageWrapper', this.$tabSlider).outerHeight());
                this.$sliderControls.css('display', 'block');
            } else {
                this.$sliderControls.css('top', 'auto');
            }
        },
        initAutoSlide : function () {
            var _instance = this;
            this.slideInterval = setInterval(function () {
                $('input', _instance.$tabSlider).prop('checked', false);
                $('#slide' + _instance.counter).prop('checked', true);
                if(_instance.counter < _instance.count) {
                    _instance.counter++;
                } else {
                    _instance.counter = 1;
                }
            }, 5000);
        },
        swipeSlide : function (event, phase, direction, distance) {
            clearInterval(this.slideInterval);

            if(direction === 'left' && this.counter < this.count && this.slideAnimatedWithSwipe === false) {
                if (distance > this.swipingPoint) {
                    this.slideAnimatedWithSwipe = true;
                    this.counter++;
                    $('#slide' + this.counter).prop('checked', true);
                }
            } else if (direction === 'right' && this.counter > 1 && this.slideAnimatedWithSwipe === false) {
                if (distance > this.swipingPoint) {
                    this.slideAnimatedWithSwipe = true;
                    this.counter--;
                    $('#slide' + this.counter).prop('checked', true);
                }
            }

            if (phase === 'end') {
                this.slideAnimatedWithSwipe = false;
            }
        }
    };
    // plugin definition
    $.fn.initTabSlider = function () {
        return new OndigoNS.TabSlider(this);
    };
    $.fn.initTabSlider.Constructor = OndigoNS.TabSlider;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $tabSlider = $('.tabSlider');
    if ($tabSlider.length) {
        $.each($tabSlider, function () {
            $(this).initTabSlider();
        });
    }
});